import React from "react";
import { Avatar, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1, 0.5),
    height: "100%",
  },
  quote: {
    fontFamily: "Roboto, sans-serif",
    fontWeight: 300,
    lineHeight: 1.55,
    fontSize: "1rem",
    color: "rgba(255,255,255,0.9)",
    flexGrow: 1,
    marginBottom: theme.spacing(2.5),
    "&::before": {
      content: '"\\201C"',
      opacity: 0.35,
      marginRight: 4,
    },
    "&::after": {
      content: '"\\201D"',
      opacity: 0.35,
      marginLeft: 4,
    },
  },
  personRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  avatar: {
    width: 36,
    height: 36,
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.22)",
    color: "rgba(255,255,255,0.75)",
    flexShrink: 0,
  },
  meta: {
    display: "flex",
    flexDirection: "column",
  },
  name: {
    fontFamily: "Roboto Mono, monospace",
    fontSize: "0.85rem",
    fontWeight: 500,
    color: "rgba(255,255,255,0.95)",
    lineHeight: 1.2,
  },
  sub: {
    fontFamily: "Roboto Mono, monospace",
    fontSize: "0.7rem",
    color: "rgba(255,255,255,0.5)",
    letterSpacing: "0.02em",
    marginTop: 2,
  },
}));

const iconProps = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const ManSilhouette = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="7.5" r="3" />
    <path d="M5.5 20v-1.2c0-2.8 2.9-4.5 6.5-4.5s6.5 1.7 6.5 4.5V20" />
  </svg>
);

const WomanSilhouette = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="7.5" r="3" />
    <path d="M8.5 5c-.6-1.5 0-3 3.5-3s4.1 1.5 3.5 3" />
    <path d="M8.7 9.2 7 12.5" />
    <path d="M15.3 9.2 17 12.5" />
    <path d="M5.5 20v-1.2c0-2.8 2.9-4.5 6.5-4.5s6.5 1.7 6.5 4.5V20" />
  </svg>
);

const NbSilhouette = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="7.5" r="3" />
    <path d="M5.5 20v-1.2c0-2.8 2.9-4.5 6.5-4.5s6.5 1.7 6.5 4.5V20" />
    <path d="M3.5 12h17" strokeDasharray="1.5 2" />
  </svg>
);

const iconForGender = (gender) => {
  if (gender === "f") return <WomanSilhouette />;
  if (gender === "m") return <ManSilhouette />;
  return <NbSilhouette />;
};

export const TestimonialCard = ({ name, age, occupation, gender, quote, photo }) => {
  const classes = useStyles();

  return (
    <Box className={classes.card}>
      <Typography component="p" className={classes.quote}>
        {quote}
      </Typography>
      <Box className={classes.personRow}>
        <Avatar className={classes.avatar} src={photo || undefined} alt={name}>
          {iconForGender(gender)}
        </Avatar>
        <Box className={classes.meta}>
          <Typography component="span" className={classes.name}>
            {name}
          </Typography>
          <Typography component="span" className={classes.sub}>
            {age} &middot; {occupation}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
